import FlashLib from "flashlib";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import SoundManager from "Engine/soundManager/SoundManager";
import {TweenMax, Linear} from "gsap";
import Animation from "Engine/base/animation/Animation";
import EntryPoint from "Engine/EntryPoint";

export default class NearWinContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.neatWinAnimation = null;
        this.animationName = 'animation';

        this.init();
        this.addListeners();
        this.createTweens();
    }

    init() {
        this.neatWinAnimation = new Animation('neat_win');
        this.neatWinAnimation.visible = false;
    }

    addListeners() {
        GlobalDispatcher.add('reelsContainer:reelsStopped', this.onReelsStopped, this);
        GlobalDispatcher.add('reel:stopped', this.onReelStopped, this);
    }

    createTweens() {
        this.showTween = TweenMax.fromTo(this.neatWinAnimation, 0.1, {alpha: 0}, {alpha: 1, ease: Linear.easeNone, paused: true});

        this.hideTween = TweenMax.to(this.neatWinAnimation, 0.1, {alpha: 0, ease: Linear.easeNone,
            paused: true,
            onComplete: this.onHideTweenComplete,
            callbackScope: this
        });
    }

    onReelsStopped(event) {
        SoundManager.stop('sounds/mainGame/Anticipation');
        this.hideTween.play(0);
    }

    onReelStopped(event) {
        this.addNearWinAnimation(event.params);
    }

    addNearWinAnimation(data) {
        if (EntryPoint.NearWinCalculator.nearReels.indexOf(data) !== -1) {
            this.place = this.getChildByName('place_' + data);
            this.place.addChild(this.neatWinAnimation);

            this.neatWinAnimation.stop();
            this.neatWinAnimation.play(true, this.animationName);
            //let newX = EntryPoint.configData.symbols.width * data + EntryPoint.configData.symbols.width / 2;//this.neatWinAnimation.width / 2;
            //let newY = EntryPoint.configData.symbols.height * EntryPoint.configData.reels.symbolsInReel / 2; //this.neatWinAnimation.height / 2;

            SoundManager.stop('sounds/mainGame/Anticipation');
            SoundManager.play('sounds/mainGame/Anticipation', 1);
            //this.neatWinAnimation.x = newX + this.reelsOffset * data;
            //this.neatWinAnimation.y = newY;

            TweenMax.killTweensOf(this.neatWinAnimation);
            this.showTween.play(0);
            this.neatWinAnimation.visible = true;
        } else {
            TweenMax.killTweensOf(this.neatWinAnimation);
            this.hideTween.play(0);
        }
    }

    onHideTweenComplete() {
        this.neatWinAnimation.visible = false;
        this.neatWinAnimation.stop();
    }
}